import { getAllLanguage } from 'apis/common.api';
import AlertEmpty from 'components/Modals/AlertEmpty';
import { IAppActionTypes, INotifer } from 'models/IAppState';
import { Dispatch } from 'redux';

export const setLoading = (isLoading: boolean) => ({
  type: IAppActionTypes.SET_LOADING,
  payload: isLoading,
});
